<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>我的收藏</b>
        <div class="tips">
          <a
            href="javascript:;"
            @click="dialogFavoritesVisible = true"
            class="uc-btn blue-plain el-icon-plus"
            >新增收藏夹</a
          >
        </div>
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入搜索关键字"
          class="uc-input"
          v-model="query.keyword"
        />
        <a
          href="javascript:;"
          @click="
            query.pageIndex = 1;
            initData();
          "
          class="uc-btn blue"
          ><i class="uc-font uc-search"></i
        ></a>
      </div>
    </div>

    <section class="uc-userCenterTitleTab3 bg-white">
      <div class="table">
        <table>
          <tr>
            <th>序</th>
            <th style="width:38%;" class="left">名称</th>
            <th style="width:10%;">课程数</th>
            <th style="width:10%;">资源数</th>
            <th style="width:22%;">修改时间</th>
            <th style="width:10%;">操作</th>
          </tr>
          <tr v-if="list.total_count == 0">
            <td colspan="6">
              <div class="content-empty">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
            </td>
          </tr>

          <tr v-for="(item, index) in list.items" :key="index">
            <td>{{ item.row }}</td>
            <td class="left">
              <router-link
                :to="{
                  name: 'PersonalFavoritesDetails',
                  params: { id: item.id },
                }"
              >
                <img src="../../assets/images/folder.png" />
                {{ item.name }}
              </router-link>
            </td>
            <td class="uc-orange">
              <b>{{ item.course_count }}</b>
            </td>
            <td class="uc-orange">
              <b>{{ item.knowledge_count }}</b>
            </td>
            <td>{{ item.create_time }}</td>
            <td>
              <router-link to="">
                <el-tooltip content="编辑" placement="top">
                  <i
                    class="el-icon-edit-outline"
                    @click="
                      dialogFavoritesVisible = true;
                      getFavoritesDetails(item.id);
                    "
                  ></i>
                </el-tooltip>
              </router-link>
              <router-link to="">
                <el-tooltip content="删除" placement="top">
                  <i
                    class="el-icon-delete uc-ml15"
                    @click="handelDeleteFavorites(item)"
                  ></i>
                </el-tooltip>
              </router-link>
            </td>
          </tr>
        </table>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

    <el-dialog
      title="收藏夹"
      :visible.sync="dialogFavoritesVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseDialog"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-input v-model="form.id" type="hidden"></el-input>
        <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
          <el-input v-model.trim="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="description"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            v-model.trim="form.description"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCloseFavorites">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PersonalFavorites',
  data() {
    return {
      dialogFavoritesVisible: false,
      query: {
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      list: [],
      gridData: [],
      form: {
        id: 0,
        name: '',
        description: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入收藏夹名称', trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getFavorites();
    },
    async getFavorites() {
      const response = await this.$api.favorites.getFavorites(this.query);
      this.list = response.data.data;
    },
    // 获取收藏夹详情
    async getFavoritesDetails(favoritesId) {
      const response = await this.$api.favorites.getFavoritesDetails({
        id: favoritesId,
      });
      this.form = response.data.data;
    },
    // 提交数据
    handleSubmitSure() {
      const submitData = {
        id: this.form.id,
        name: this.form.name,
        description: this.form.description,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.postFavorites(submitData);
        }
      });
    },
    async postFavorites(myFavorites) {
      const response = await this.$api.favorites.postFavorites(myFavorites);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);

        this.dialogFavoritesVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleCloseFavorites() {
      this.dialogFavoritesVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    handelDeleteFavorites(item) {
      const confirmText = [
        '确定要删除该收藏夹吗？',
        '注意：删除之后对应收藏的内容也会释放！',
      ];
      const newDatas = [];
      const h = this.$createElement;
      for (const i of Object.keys(confirmText)) {
        newDatas.push(h('p', null, confirmText[i]));
      }
      this.$confirm('提示', {
        type: 'warning',
        title: '提示',
        message: h('div', null, newDatas),
      })
        .then(() => {
          this.$api.favorites
            .deleteFavorites({ id: item.id })
            .then((response) => {
              if (response.data.code === 200) {
                this.list.items.splice(this.list.items.indexOf(item), 1);
                this.$message.success(response.data.message);
              } else {
                this.$message.warning(response.data.message);
              }
            });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
  },
};
</script>
